import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { GoogleMapsLoaderService } from 'src/app/services/google-maps-loader.service';
import { CustomErrorMessagesService } from './services/custom-error-messages.service';
import { GET_ERROR_MESSAGE_FN_TOKEN } from '@bioreferencehealth/ui-kit';
import { googleApiLibraries } from 'src/app/constants/google-api-libaries.const';
import { NOTIFICATION_MAX_ITEMS } from '@bioreferencehealth/ui-kit';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ExpiredAppointmentService } from './services/expired-appointment.service';
import { AppErrorHandler } from './app-error-handler';
import { IosDeviceService } from './services/ios-device.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withViewTransitions(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      })
    ),
    provideHttpClient(),
    provideAppInitializer(() => {
      const googleMapLoader = inject(GoogleMapsLoaderService);
      return googleMapLoader.load(googleApiLibraries);
    }),
    provideAppInitializer(() => {
      const expiredAppointmentService = inject(ExpiredAppointmentService);
      expiredAppointmentService.checkAndResetBookingAppointmentIfExpired();
    }),
    provideAppInitializer(() => {
      const iosDeviceService = inject(IosDeviceService);
      iosDeviceService.addIosClassToHtmlTag();
    }),
    CustomErrorMessagesService,
    ExpiredAppointmentService,
    IosDeviceService,
    {
      provide: GET_ERROR_MESSAGE_FN_TOKEN,
      useFactory: (service: CustomErrorMessagesService): unknown => {
        return service.getErrorMessage.bind(service);
      },
      deps: [CustomErrorMessagesService]
    },
    { provide: NZ_I18N, useValue: en_US },
    [{ provide: NOTIFICATION_MAX_ITEMS, useValue: 5 }],
    provideAnimations(),
    { provide: ErrorHandler, useClass: AppErrorHandler }
  ]
};
